/**
 * About me section (not to be confused with the landing prompt)
 * Includes the skills section, timeline as well as any dialogue
 * about myself
 */
import React from 'react';

// material import
import { Grid } from '@material-ui/core';

// style imports 
import { AboutGridContainer, AboutSectionContainer 

} from '../../../styles/sectionStyles/AboutSectionStyles';

// core styles
import { SectionHeader, SectionText, SectionSubheader } from '../../../styles/CoreStyle';

// react-reveal fade animation
import { Fade } from 'react-reveal';

// timeline component import
import WorkHistoryTimeline from './Timeline';
// skills import
import Skills from './Skills';

import PortableText from '../../../../core/sanity/content/portableText';

export function AboutSection ({ bio, name }) {
  return (
    <AboutSectionContainer>
      <Fade>
        <SectionHeader id="about">Hi I'm {name},</SectionHeader>
        <SectionText>
          <PortableText blocks={bio} />
        </SectionText>
      </Fade>
        <Grid container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{height: '80%', marginTop: '60px'}}
        >
          <Fade bottom>
            <Grid item>
              <AboutGridContainer>
                <SectionSubheader>What I use</SectionSubheader>
                <Skills />
              </AboutGridContainer>
            </Grid>
          </Fade>
          <Fade bottom>
            <Grid item>
              <AboutGridContainer>
                <SectionSubheader>Experience</SectionSubheader>
                <WorkHistoryTimeline />
              </AboutGridContainer>
            </Grid>
          </Fade>
        </Grid>

    </AboutSectionContainer>
  );
}